import React, { useState } from "react";
import { Outlet, NavLink } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { NAV, canAccess } from "@/lib/nav";
import { useAuth } from "@/context/AuthContext";
import { cn } from "@/lib/utils";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import BrandLogo from "@/components/common/BrandLogo";

export const AppLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user } = useAuth();
  const items = NAV.filter((n) => canAccess(user, n.module));

  return (
    <div className="flex h-dvh overflow-hidden bg-background">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />

      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent side="left" className="w-72 p-0 bg-sidebar border-none">
          <div className="flex items-center h-16 px-5 border-b border-white/5">
            <div className="flex items-center gap-3">
              <img
                src="/assets/logo-white.png"
                alt="StayServe"
                className="h-8 w-auto object-contain"
              />

              <div>
                <div className="font-display text-[12px] font-black tracking-tight leading-none">
                  <span className="text-[#ffffff]">Stay</span>
                  <span className="text-[#FF6B00]">Serve</span>
                </div>

                <div className="mt-1 text-[5px] font-bold uppercase tracking-[.20em] text-[#ffffff]">
                  Hospitality operations
                </div>
              </div>
            </div>
          </div>
          <nav className="py-4 px-3 space-y-1">
            {items.map((n) => (
              <NavLink
                key={n.key}
                to={n.to}
                end={n.to === "/app"}
                onClick={() => setMobileOpen(false)}
                className={({ isActive }) =>
                  cn(
                    "flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium",
                    isActive
                      ? "bg-primary text-white"
                      : "text-stone-400 hover:text-white hover:bg-white/5",
                  )
                }
              >
                <n.icon size={19} /> {n.label}
              </NavLink>
            ))}
          </nav>
        </SheetContent>
      </Sheet>

      <div className="flex-1 flex flex-col min-w-0">
        <Topbar onMobileNav={() => setMobileOpen(true)} />
        <main className="flex-1 min-w-0 min-h-0 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
